import { Col, Empty, Row } from 'antd';
import React from 'react';
import { BsFolder } from 'react-icons/bs';
import { FaFileCsv } from 'react-icons/fa';
import { DataRoom } from '../../main/deals/redux/types';
import BackDrop from '../BackDrop';
// import Checkbox, { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox';
import moment from 'moment';
import { AiOutlineFileExcel, AiOutlineFilePdf } from 'react-icons/ai';
import { PiFileTextDuotone } from 'react-icons/pi';

type Props = {
    data: DataRoom[];
    onClickOnFolderOrFile: (data: DataRoom) => void;
    loader: string | undefined;
};

const TreeView: React.FC<Props> = ({ data, onClickOnFolderOrFile, loader }) => {
    const fileIcon = (name: string) => {
        const extension = name.substring(name.lastIndexOf('.') + 1);
        switch (extension) {
            case 'pdf':
                return <AiOutlineFilePdf className="mr-2 text-[#7C7B7B]" size="1.4rem" />;
            case 'csv':
                return <FaFileCsv className="mr-2 text-[#7C7B7B]" size="1.4rem" />;
            case 'xlsx':
            case 'xls':
                return <AiOutlineFileExcel className="mr-2 text-[#7C7B7B]" size="1.4rem" />;
            default:
                return <PiFileTextDuotone className="mr-2 text-[#7C7B7B]" size="1.4rem" />;
        }
    };

    return (
        <div id="dataroom">
            <Row gutter={[16, 16]} className="py-2">
                {/* {columns.map((d, index) => ( */}
                <Col xs={12}>
                    <div className={`flex items-center  pl-2`}>
                        {<p className="mr-1 ml-0.5 w-4 h-4" />}
                        <p className="flex items-center cursor-pointer font-[WorkSans-Semibold] font-bold text-sm text-[#5C5C5C]">
                            {'Name'}
                            {/* {orderBy && orderBy === d.key ? order === 'desc' ? <BsArrowDown className="ml-1" /> : <BsArrowUp className="ml-1" /> : null} */}
                        </p>
                    </div>
                </Col>
                <Col xs={12}>
                    <div className={`flex items-center pr-2 text-center justify-end md:justify-start`}>
                        <p className="flex items-center cursor-pointer font-[WorkSans-Semibold] font-bold text-sm text-[#5C5C5C]">
                            {'Last Updated At'}
                        </p>
                    </div>
                </Col>
                {/* ))} */}
            </Row>
            {data.map((d, index) => (
                <Row
                    gutter={[16, 16]}
                    key={`${d.uuid}_${index}`}
                    className="py-3 my-1 flex items-center rounded-md bg-[#E4F1FF]"
                >
                    <Col xs={12} className="cursor-pointer">
                        {/* {loading !== d.uuid && ( */}
                        <div className="text-xs font-semibold pl-2 flex items-center text-[#000000]">
                            <div
                                onClick={() => {
                                    if (loader === undefined) {
                                        onClickOnFolderOrFile(d);
                                    }
                                }}
                                key={`data_room_folder_file_${index}`}
                                className="px-4 cursor-pointer dataRoom_row"
                            >
                                <div className="flex items-center">
                                    <p>{d.type === 'Folder' && <BsFolder className="mr-2" size="1.2rem" />}</p>
                                    <p>{d.type === 'File' && fileIcon(d.name)}</p>
                                    <p className="text-sm WorkSans font-normal  text-[#000000]">{d.name}</p>
                                    {loader === `${d.uuid}_${d.name}` && <BackDrop />}
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} className="flex justify-end md:justify-start">
                        <p className="text-sm WorkSans font-normal text-[#000000] pr-2">
                            {d.audit?.updatedAt ? moment(d.audit?.updatedAt).format('DD-MM-YYYY hh:mm:ss') : '-'}
                        </p>
                    </Col>
                </Row>
            ))}
            {data.length === 0 && (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<p className="text-lg WorkSans font-semibold text-gray-500">No data available</p>}
                />
            )}
        </div>
    );
};

export default TreeView;
